import { ropCardEventToCard } from "../../dashboard/helpers/dados-indicadores-converter";
import type { RopCardBase } from "../../dashboard/models/dados-indicadores.model";
import {
  EnumRopCards,
  type RopCard,
} from "../../dashboard/models/dados-indicadores.model";
import type { SolarGridControlSSEData } from "../../dashboard/models/solar-grid-control-model";
import { CardTypesEnum } from "../../dashboard/types";
import type {
  SolarGridControlData,
  SolarGridControlTelemetryData,
} from "../types";
import type { RopCard3003LiveSingleLineDiagram } from "./ropCard3003LiveSingleLineDiagram.types";

const emptySolarGridControlData: SolarGridControlData = {
  potenciaAtiva: null,
  tensaoDeLinha: null,
  energiaHoje: null,
  disponibilidadeDoSistema: null,

  plantaEnergiaGerada: null,
  evolutionChartData: null,

  telemetryData: null,

  stringCurrents: null,
};

type SolarGridControlDataAction =
  | {
      type: "RESET_CONNECTION";
    }
  | {
      type: "ROP_CARD_UPDATE";
      payload: RopCardBase;
    }
  | {
      type: "SOLAR_GRID_CONTROL_CARD_UPDATE";
      payload: SolarGridControlSSEData;
    };

export function solarGridControlDataReducer(
  state: SolarGridControlData | null,
  action: SolarGridControlDataAction,
): SolarGridControlData | null {
  switch (action.type) {
    case "RESET_CONNECTION":
      return null;

    case "ROP_CARD_UPDATE":
      const updatedDataFromRopCard = handleRopCardUpdate(action.payload);
      return {
        ...(state ?? emptySolarGridControlData),
        ...updatedDataFromRopCard,
      };

    case "SOLAR_GRID_CONTROL_CARD_UPDATE":
      const updatedDataFromSolarGridControlCard =
        handleSolarGridControlCardUpdate(action.payload);
      return {
        ...(state ?? emptySolarGridControlData),
        ...updatedDataFromSolarGridControlCard,
      };

    default:
      return state;
  }
}

function handleRopCardUpdate(
  ropCardUpdate: RopCardBase,
): Partial<SolarGridControlData> {
  const expectedRopCardTypes = [
    EnumRopCards.RopCard03EnergiaGerada,
    EnumRopCards.RopCard05Disponibilidade,
    EnumRopCards.RopCard07GraficoEvolucaoChart,
    EnumRopCards.RopCard13EnergiaPorEquipamento,
    EnumRopCards.RopCard17TensaoDeLinha,
    EnumRopCards.RopCard20PotenciaAtiva,
  ];

  if (expectedRopCardTypes.includes(ropCardUpdate.type)) {
    const updatedCardConfig = ropCardEventToCard(ropCardUpdate as RopCard);
    switch (updatedCardConfig.card.type) {
      case CardTypesEnum.EnergiaGerada:
        return {
          energiaHoje: updatedCardConfig.card.data.value ?? null,
        };

      case CardTypesEnum.Disponibilidade:
        return {
          disponibilidadeDoSistema: updatedCardConfig.card.data.value ?? null,
        };

      case CardTypesEnum.EvolucaoGeracao:
        return {
          evolutionChartData: updatedCardConfig.card.data.data,
        };

      case CardTypesEnum.GeracaoPlanta:
        return {
          plantaEnergiaGerada: updatedCardConfig.card.data.data.planta,
        };

      case CardTypesEnum.TensaoDeLinha:
        return {
          tensaoDeLinha: updatedCardConfig.card.data.value ?? null,
        };

      case CardTypesEnum.PotenciaAtiva:
        return {
          potenciaAtiva: updatedCardConfig.card.data.value ?? null,
        };

      default:
        console.error(
          "RopCard esperado com tipo inesperado para controle de rede solar",
          {
            ropCardUpdate,
            updatedCardConfig,
          },
        );
        return {};
    }
  }

  if (ropCardUpdate.type === EnumRopCards.RopCard3003LiveSingleLineDiagram) {
    // console.debug("RopCard3003LiveSingleLineDiagram recebido:", ropCardUpdate);

    const ropCard3003 = ropCardUpdate as RopCard3003LiveSingleLineDiagram;

    const telemetryData: SolarGridControlTelemetryData = {
      componentOperationalStatuses: ropCard3003.componentOperationalStatuses,
    };

    return {
      telemetryData,
    };
  }

  console.error("RopCard inesperado para controle de rede solar", {
    ropCardUpdate,
  });

  return {};
}

function handleSolarGridControlCardUpdate(
  solarGridControlCardUpdate: SolarGridControlSSEData,
): Partial<SolarGridControlData> {
  return {
    stringCurrents: solarGridControlCardUpdate.stringCurrents,
  };
}
